import React, { useState , useEffect} from "react";
import styles from "./signup.module.scss"
import logoImg from "../../app/images/logo.png"
import {Box, TextField, FormControlLabel, Checkbox, Button, Typography} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { signup } from "../../app/data/api";

const SignUp: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [telNumber, setTelNumber] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signup (username , password, email);
      navigate("/login"); 
    } catch (err: any) {
      setError(err.response?.data?.message || "Sign-Up failed");
    }
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperInner}>
        <div className={styles.logoWrap}>
            <img src={logoImg} alt="logoImg"/>
        </div>
        <h3 className={styles.title}>Sign Up</h3>
        <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "24px",
        width: "100%",
        mx: "auto",
      }}
    >
         {error && <Typography color="error">{error}</Typography>}
      <TextField
        label="Username"
        variant="outlined"
        placeholder="Enter username"
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={username}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setUsername(e.target.value)}
      />

<TextField
        label="Telephone number"
        variant="outlined"
        placeholder="Enter telephone number"
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={telNumber}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setTelNumber(e.target.value)}
      />
<TextField
        label="E-mail"
        variant="outlined"
        placeholder="Enter e-mail"
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={email}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setEmail(e.target.value)}
      />
      

      <TextField
        label="Password"
        variant="outlined"
        type="password"
        InputLabelProps={{ shrink: true }}
        placeholder="Enter password"
        fullWidth
        value={password}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className={styles.detailsWrap}>
        <FormControlLabel
          control={<Checkbox className={styles.checkBox} size="small" color="primary" sx={{ transform: "scale(0.8)", fontSize: "10px" , "@media (max-width: 600px)": { transform: "scale(0.5)" } }} />}
          label="keep me logged in"
          sx={{ 
            gap: "0px",       
            "& .MuiTypography-root": { 
              fontSize: "14px", 
              "@media (max-width: 600px)": { fontSize: "12px" } 
            } 
          }}
        />
        <Link to="" className={styles.forgotLink} >
         forgot password?
        </Link>
      </div>

      <Button
        variant="contained"
        color="error"
        fullWidth
        sx={{ borderRadius: "10px", width: "162px", height: "40px", fontSize: "16px", fontWeight: "600", margin: "0 auto" }}
        onClick={handleSubmit}
      >
        Sign Up
      </Button>
        </Box>
        <div className={styles.optionsWrap}>
          <p>Already have an account?</p>
          <Link className={styles.optionsLink} to="/login">Sign in <ArrowForwardIcon /></Link>
        </div>
       
      </div>
    </div>
  );
};

export default SignUp;